// extracted by mini-css-extract-plugin
module.exports = {"Headcounts":"Headcounts_Headcounts__3ZUHi","HeadcountBox":"Headcounts_HeadcountBox__140EO","HeadcountRow":"Headcounts_HeadcountRow__2meN7"};